import { ChangeEvent, FC } from 'react';
import { Switch, SwitchProps, SxProps, Theme, styled, useTheme } from '@mui/material';

interface IOSSwitchProps {
  isChecked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
  isDisabled?: boolean;
}

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(() => {
  const theme = useTheme();

  return {
    width: '42px',
    height: '20px',
    marginLeft: '12px',
    marginRight: '16px',
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: '3px 4px',
      transitionDuration: '0.3s',
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: '14px',
      height: '14px',
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.grey[30],
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  };
});

const IOSSwitch: FC<IOSSwitchProps> = ({
  sx,
  isChecked,
  isDisabled = false,
  onChange,
}) => {
  return (
    <CustomSwitch sx={sx} checked={isChecked} disabled={isDisabled} onChange={onChange} />
  );
};

export default IOSSwitch;
